const i18n = {
  'en-US': {
    'login.form.title': 'Login to 速问',
    'login.form.userName.errMsg': 'Username cannot be empty',
    'login.form.password.errMsg': 'Password cannot be empty',
    'login.form.login.errMsg': 'Login error, please refresh and try again',
    'login.form.userName.placeholder': 'Please enter username',
    'login.form.password.placeholder': 'Please enter password',
    'login.form.rememberPassword': 'Remember password',
    'login.form.forgetPassword': 'Forgot password',
    'login.form.login': 'login',
    'login.form.register': 'register account',
    'login.banner.slogan1': 'Out-of-the-box high-quality template',
    'login.banner.subSlogan1':
      'Rich page templates, covering most typical business scenarios',
    'login.banner.slogan2': 'Built-in solutions to common problems',
    'login.banner.subSlogan2':
      'Internationalization, routing configuration, state management everything',
    'login.banner.slogan3': 'Access visualization enhancement tool AUX',
    'login.banner.subSlogan3': 'Realize flexible block development',
  },
  'zh-CN': {
    'login.form.title': '登录 速问',
    'login.form.userName.errMsg': '用户名不能为空',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.login.errMsg': '登录出错，请刷新重试',
    'login.form.userName.placeholder': '请输入用户名',
    'login.form.password.placeholder': '请输入密码',
    'login.form.rememberPassword': '记住密码',
    'login.form.forgetPassword': '忘记密码',
    'login.form.login': '登录',
    'login.form.register': '注册账号',
    'login.banner.slogan1': '速问，洞悉医疗新未来',
    'login.banner.subSlogan1': '整合行业数据，助力精准决策，开启医疗新篇章',
    'login.banner.slogan2': '精准分析，赋能医药决策',
    'login.banner.subSlogan2': '提供全面洞察，支持订阅查询，优化您的业务选择',
    'login.banner.slogan3': '大数据驱动，行业趋势尽掌握',
    'login.banner.subSlogan3': '从政策到销售，一站式平台，助您领先市场一步',
  },
};

export default i18n;
